<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button type="button" class="btn btn-warning" @click="createBank">
                        <icon name="plus"></icon>
                        เพิ่มธนาคาร
                    </button>
                    &nbsp
                    <button @click="viewreport"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon>
                        รายงานธนาคาร
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">รายการ</th>
                    <th scope="col">ชื่อบัญชี</th>
                    <th scope="col">เลขที่บัญชี</th>
                    <th scope="col">ชื่อธนาคาร</th>
                    <th scope="col">สาขาธนาคาร</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in BankList">
                    <td>{{ data.name }}</td>
                    <td>{{ data.account_name }}</td>
                    <td>{{ data.account_number }}</td>
                    <td>{{ data.bank_name }}</td>
                    <td>{{ data.bank_branch }}</td>
                    <td>
                        <a @click="showBank(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getPage">
        </vue-pagination>
        <br/>
        <!--add data-->
        <b-modal hide-footer hide-header ref="add_bank">
            <bank-data-modal @submit="submitBank"></bank-data-modal>
        </b-modal>

        <!--delete data-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteBankData"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import BankDataModal from "./BankDataModal";
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import {domain} from "../../../util/Constants";

export default {
    components: {
        VuePagination,
        BankDataModal
    },
    name: "bank-list",
    data() {
        return {
            delete_id: "",
            page: 1,
        }
    },
    created() {
        this.$store.dispatch("Bank/setBank");
    },
    computed: {
        ...mapState({
            BankList: state => {
                return state.Bank.bankTable;
            },
            dataPaginate: state => {
                return state.Bank.dataPaginate
            }
        })
    },
    methods: {
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showAddBankModal() {
            this.$refs.add_bank.show();
        },
        hideAddBankModal() {
            this.$refs.add_bank.hide();
        },
        showBank(id) {
            this.$store.dispatch("Bank/showBank", id).then(() => {
                this.showAddBankModal();
            });
        },
        viewreport() {
            window.open(`${domain}/tableau/reportBank`);
        },
        createBank() {
            this.$store.dispatch("Bank/clearData").then(() => {
                this.showAddBankModal();
            });
        },
        submitBank(value) {
            //console.log(value);
            if (value) {
                this.$store.dispatch("Bank/saveBank", {
                    id: value.id,
                    data: value
                });
            }
            this.hideAddBankModal();
            this.$store.dispatch("Bank/setBank");
        },
        deleteBankData() {
            this.$store.dispatch("Bank/deleteBank", this.delete_id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("Bank/setBank");
            });
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            this.$store.dispatch("Bank/setBank", this.page);
        }
    }
}
</script>

<style scoped>

</style>
